import React, { useEffect, useState } from 'react';
import ReactEcharts from 'echarts-for-react';
import API from '../../../api';

const StatDevis = () => {
    const [etatPercentages, setEtatPercentages] = useState([]);
    const [stat, setStat] = useState([]);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await API.post('devi/get_stat');
                const data = response.data.DevisClient[0];

                // Process and set the state for etat_percentages
                const etatPercentagesData = [
                    { value: parseFloat(data.etat_percentages.total), name: 'total' },
                    { value: parseFloat(data.etat_percentages.partielle), name: 'partielle' },
                    { value: parseFloat(data.etat_percentages['non satisfait']), name: 'non satisfait' },

                ];
            
                setEtatPercentages(etatPercentagesData);

                // Set the state for stat
                setStat(data.etat_facturation_percentages[0]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        fetchData();
    }, []);
console.log(stat)
    const getOptionEtat = () => {
        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c} ({d}%)',
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                data: ['total', 'partielle', 'non satisfait'],
                textStyle: {
                    color: ['#74788d'],
                },
            },
            color: ['#02a499', '#f8b425', '#ec4561', '#38a4f8', '#3c4ccf'],
            series: [
                {
                    name: 'Total sales',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: etatPercentages,
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        },
                    },
                },
            ],
        };
    };

    const getOptionFacturation = () => {
        return {
            tooltip: {
                trigger: "axis",
            },
            grid: {
                zlevel: 0,
                x: 50,
                x2: 50,
                y: 30,
                y2: 30,
                borderWidth: 0,
            },
            xAxis: {
                type: "category",
                data: ["total_facture", "non facturé", "facturé"],
                axisLable: {
                    color: "#ffffff",
                },
                axisLine: {
                    lineStyle: {
                        color: "#74788d",
                    },
                },
            },
            yAxis: {
                type: "value",
                axisLable: {
                    color: "#ffffff",
                },
                axisLine: {
                    lineStyle: {
                        color: "#74788d",
                    },
                },
            },
            series: [
                {
                    data: [stat.tot,stat.facture,stat.nonFacture],
                    type: "line",
                },
            ],
            color: ["#556ee6"],
            textStyle: {
                color: ["#74788d"],
            },
        }
    }
    return (
        <div style={{ display: 'flex' }}>
            <div style={{ flex: 1, marginRight: '20px' }}>
                <p>État Devis</p>
                <ReactEcharts style={{ height: '350px' }} option={getOptionEtat()} />
            </div>
            <div style={{ flex: 1 }}>
                <p>État Facturation</p>
                <ReactEcharts style={{ height: '350px' }} option={getOptionFacturation()} />
            </div>
        </div>
    );
};
export default StatDevis;
